import { ShoppingCartOutlined } from '@ant-design/icons';
import { Badge } from 'antd';
import { useEffect, useState } from 'react';
import { isEmpty } from 'underscore';
import useGetShoppingCartQuery from '../../../../queries/useGetShoppingCartQuery';
import styles from '../style/ShoppingCartButton.module.scss';

export default function ShoppingCartButton() {
  const { data } = useGetShoppingCartQuery();

  const shoppingItems = data?.shoppingItems || {};
  const [shoppingItemsCount, setShoppingItemsCount] = useState(0);

  useEffect(() => {
    let noItems = 0;
    if (!isEmpty(shoppingItems)) {
      Object.keys(shoppingItems).forEach((pointName: string) => {
        noItems += Object.keys(shoppingItems[pointName]).length;
      });
    }
    setShoppingItemsCount(noItems);
  }, [shoppingItems]);

  return (
    <Badge
      count={shoppingItemsCount}
      classNames={{ indicator: 'Header-Cart_Count' }}
      className={styles.cartBadge}
    >
      <ShoppingCartOutlined className={styles.cartIcon} />
    </Badge>
  );
}
